import { render } from "./CircularProgressBar.vue?vue&type=template&id=bc70161e"
import script from "./CircularProgressBar.vue?vue&type=script&lang=ts"
export * from "./CircularProgressBar.vue?vue&type=script&lang=ts"
script.render = render

export default script